<tn-dialog-shell testId="multi-error" [title]="'Multiple Errors' | translate">
  <div class="multi-error-dialog">
    @for (error of errors; track error) {
      <ix-error-template
        class="error-template"
        [index]="$index"
        [title]="error.title"
        [message]="error.message"
        [stackTrace]="error.stackTrace"
        [logs]="error.logs"
      ></ix-error-template>
      <tn-divider></tn-divider>
    }
  </div>

  <div tnDialogAction>
    <tn-button
      testId="close-error-dialog"
      [label]="'Close' | translate"
      (onClick)="dialogRef.close(true)"
    ></tn-button>
  </div>
</tn-dialog-shell>
